import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TextFieldData from "./TextFiledData"; // Fixed import name
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import { put, api, get } from "../../../utils/api";
import Table from "./TableData";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const Economic227 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [fromData, setFromData] = useState({
    totalNonComplianceInstances: {
      totalValue: "",
      monetory: "",
      nonmonetory: "",
    },

    numberOfFines: {
      total: "",
      currentPeriod: "",
      previousPeriod: "",
    },
    monetoryValue: {
      total: "",
      currentPeriod: "",
      previousPeriod: "",
    },

    significantNonComplianceInstances: "",
    nonComplianceSeverityAssessment: "",
  });

  // Function to validate the form fields
  const validateFields = () => {
    const newErrors = {};

    // Loop through the 'fromData' object and validate
    Object.keys(fromData).forEach((sectionKey) => {
      const section = fromData[sectionKey];

      // If section is an object, loop through the fields inside it
      if (typeof section === "object") {
        Object.keys(section).forEach((fieldKey) => {
          if (!section[fieldKey]) {
            // If the field is empty, mark it as an error
            if (!newErrors[sectionKey]) {
              newErrors[sectionKey] = {};
            }
            newErrors[`${sectionKey}.${fieldKey}`] = ` required`;
          }
        });
      } else if (!section) {
        // If section is not an object, just check the value
        newErrors[sectionKey] = `required`;
      }
    });
    console.log(newErrors);
    setErrors(newErrors);
    return newErrors;
  };

  const fetchData = async () => {
    await get(`/gri/get?type=GeneralDisclosures2021&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false)
          setDisabled(true);
        setFromData({
          totalNonComplianceInstances: {
            totalValue:
              res.data.data.GeneralDisclosures2021.compinaceWithLaws
                ?.totalNonComplianceInstances.totalValue,
            monetory:
              res.data.data.GeneralDisclosures2021?.compinaceWithLaws
                ?.totalNonComplianceInstances?.monetory,
            nonmonetory:
              res.data.data.GeneralDisclosures2021.compinaceWithLaws
                ?.totalNonComplianceInstances?.nonmonetory,
          },

          numberOfFines: {
            total:
              res.data.data.GeneralDisclosures2021.compinaceWithLaws
                ?.numberOfFines?.total,
            currentPeriod:
              res.data.data.GeneralDisclosures2021?.compinaceWithLaws
                ?.numberOfFines.currentPeriod,
            previousPeriod:
              res.data.data.GeneralDisclosures2021?.compinaceWithLaws
                ?.numberOfFines?.previousPeriod,
          },
          monetoryValue: {
            total:
              res.data.data.GeneralDisclosures2021.compinaceWithLaws
                ?.monetoryValue?.total,
            currentPeriod:
              res.data.data.GeneralDisclosures2021.compinaceWithLaws
                ?.monetoryValue?.currentPeriod,
            previousPeriod:
              res.data.data.GeneralDisclosures2021.compinaceWithLaws
                ?.monetoryValue?.previousPeriod,
          },

          significantNonComplianceInstances:
            res.data.data.GeneralDisclosures2021?.compinaceWithLaws
              ?.significantNonComplianceInstances,
          nonComplianceSeverityAssessment:
            res.data.data.GeneralDisclosures2021?.compinaceWithLaws
              ?.nonComplianceSeverityAssessment,
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Function to handle form submission
  const handleSubmit = async () => {
    if (!disabled) {
      // const validationErrors = validateFields();
      // If there are errors, prevent form submission
      // if (Object.keys(validationErrors).length > 0) {
      //   console.log("Form contains errors", fromData, validationErrors);
      //   return;
      // }
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, {
          type: "GeneralDisclosures2021",
          compinaceWithLaws: { ...fromData },
          submitted2_27: true,
        });
        navigate(`/gri/general-disclosure/2-28/${id}`);
      } catch {
        console.log(errors);
      }
    } else {
      navigate(`/gri/general-disclosure/2-28/${id}`);
    }
  };

  const inputData = [
    {
      index: "a.",
      title:
        "Report the total number of significant instances of non-compliance with laws and regulations during the reporting period.",

      subfieldName: "totalNonComplianceInstances",
      fields: [
        {
          subheading: "S.No.",
          item: [{ value: "a." }, { value: "i." }, { value: "ii." }],
        },
        {
          subheading: "Category",
          fieldName: "totalNonComplianceInstances",
          item: [
            {
              value: "Total Significant Instances of Non-Compliance",
              key: "totalValue",
            },

            {
              value: "Instances for which fines were incurred",
              key: "monetory",
            },
            {
              value: "Instances for which non-monetary sanctions were incurred",
              key: "nonmonetory",
            },
          ],
        },
        {
          subheading: "Number of Significant Instances",
          fieldName: "totalNonComplianceInstances",
          placeholder: "Enter Number",
        },
      ],
    },
    {
      index: "b.",
      title:
        "Report the total number and the monetary value of fines for instances of non-compliance with laws and regulations that were paid during the reporting period.",
      // subfieldName: "lawsAndRegulations",
      fields: [
        {
          subheading: "S.No.",
          item: [{ value: "a." }, { value: "i." }, { value: "ii." }],
        },
        {
          subheading: "Category",
          // fieldName: "lawsAndRegulations",
          item: [
            {
              value: "Total Significant Instances of Non-Compliance",
              key: "total",
            },
            {
              value: "Fines for non-compliance in the current reporting period",
              key: "currentPeriod",
            },
            {
              value: "Fines for non-compliance in previous reporting periods",
              key: "previousPeriod",
            },
          ],
        },
        {
          subheading: "Number Fines",
          fieldName: "numberOfFines",
          placeholder: "Enter Number",
        },
        {
          subheading: "Monetary Value of Fines (in currency)",
          fieldName: "monetoryValue",
          placeholder: "Enter Number",
        },
      ],
    },
  ];

  const inputDataTextField = [
    {
      index: "c.",
      heading:
        "Describe the significant instances of non-compliance with laws and regulations that occurred during the reporting period. Significant non-compliance reports should include location, issue type (e.g., tax fraud, spill), and context for user understanding. Recurring instances can be explained. ",
      fieldName: "significantNonComplianceInstances",
    },
    {
      index: "d.",
      heading:
        "Describe how organization has determined significant instances of non-compliance. The organization can assess severity of impact and consider external sector benchmarks to identify significant non-compliance instances. ",
      fieldName: "nonComplianceSeverityAssessment",
    },
  ];

  const renderContent = ({ hide }) => (
    <>
      <p className={styles.main_heading} style={{marginBottom: hide ? "-5rem" : "0rem"}}>
        2-27 Compliance with laws and regulations
      </p>
      <Table
        inputData={inputData}
        {...{
          setFromData,
          fromData,
          setErrors,
          disabled: disabled,
          errors,
          hide
        }}
        columnWidth={"10% 44% 46%"}
        // columnWidth={"13% 41% 46%"}
      />
      <TextFieldData
        inputData={inputDataTextField}
        {...{
          fromData,
          setFromData,
          setErrors,
          disabled: disabled,
          errors,
          hide,
        }}
      />
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default Economic227;
